import { Controller } from '@hotwired/stimulus';
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

export default class extends Controller {
  static targets = ['input']
  static values = {
    phoneAttributeName: String,
    initialCountry: { type: String, default: 'FR' },
    preferredCountries: { type: Array, default: ['fr', 'ch'] }
  }

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      autoHideDialCode: false,
      formatOnDisplay: true,
      hiddenInput: () => ({ phone: this.inputTarget.dataset.phoneAttributeNameValue || 'phone_number' }),
      initialCountry: this.initialCountryValue,
      nationalMode: false,
      preferredCountries: this.preferredCountriesValue,
      separateDialCode: true
    });
  }

  validate() {
    if (!this.inputTarget.value.trim()) return;

    if (this.iti.isValidNumber()) {
      this.inputTarget.classList.remove('is-invalid');
      this.inputTarget.classList.add('is-valid');
    } else {
      this.inputTarget.classList.remove('is-valid');
      this.inputTarget.classList.add('is-invalid');
    }
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
}
